import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

/** How long a warning stays (ms) when it doesn't set its own time. */
export const WARNING_LIFE_MS = 6000;
/** How long an info/success message stays (ms) when it doesn't set its own time. */
export const INFO_LIFE_MS = 4000;

/**
 * The app's MessageService (provided in place of PrimeNG's): one rule for every toast, wherever it
 * comes from. An error stays until the user closes it — it may need reading or acting on. Warnings,
 * info and success messages close by themselves after a few seconds.
 * (PrimeNG treats `life: 0` as "the default 3 s", not as "stay": that's why errors used to vanish.)
 */
@Injectable()
export class AppMessageService extends MessageService {
  override add(message: ToastMessageOptions): void {
    super.add(withLifetime(message));
  }

  override addAll(messages: ToastMessageOptions[]): void {
    super.addAll((messages ?? []).map(withLifetime));
  }
}

export function withLifetime(message: ToastMessageOptions): ToastMessageOptions {
  if (!message) return message;
  const severity = String(message.severity ?? '').toLowerCase();
  if (severity === 'error' || severity === 'danger') {
    return { ...message, sticky: true, closable: true };
  }
  const life = typeof message.life === 'number' && message.life > 0 ? message.life : severity === 'warn' ? WARNING_LIFE_MS : INFO_LIFE_MS;
  return { ...message, sticky: false, life };
}
